/// <amd-module name="Build/Shared/CreateMenuProvider" />
import * as Resources from "Build/Shared/Resources";

import { IVssPageContext, Services, VssService } from "VSS/Platform/Context";
import { IVssSecurityService } from "VSS/Platform/Security";
import { routeUrl } from "VSS/Platform/Location";
import { IMenuItem } from "VSSUI/Menu";
import { IMenuService } from "VSS/Features/PlatformUI/ContributedMenu";
import { ITfsPageService } from "Tfs/Platform/Page";
import { IStartRightExtensionService } from "VSS/Platform/StartRightExtension";

const SourceCICDActionMenu = "CICDActionMenu";

namespace Constants {
    export const BuildNamespaceId = "33344d9c-fc72-4d6f-aba5-fa317101a7e9";
    export const EditBuildDefinitionPermission = 2048;
}

class CreateMenuProviderService extends VssService implements IMenuService {
    private menuItems: IMenuItem[] = [];

    public _serviceStart(pageContext: IVssPageContext) {
        super._serviceStart(pageContext);

        const startRightService = pageContext.getService<IStartRightExtensionService>("IStartRightExtensionService");
        const tfsPageService = this.pageContext.getService<ITfsPageService>("ITfsPageService");
        const tfsPageData = tfsPageService.getData();

        if (tfsPageData && tfsPageData.project) {
            // check for permissions to edit build definitions
            const securityService = this.pageContext.getService<IVssSecurityService>("IVssSecurityService");
            const hasEditPermission = securityService.hasPermission(Constants.BuildNamespaceId, tfsPageData.project.id, Constants.EditBuildDefinitionPermission);

            const routeValues: { [key: string]: string } = {};
            routeValues["project"] = tfsPageData.project.name;
            routeValues["source"] = SourceCICDActionMenu;

            const createPipelineLink = startRightService.getCreatePipelineUrl(pageContext) ||
                                       routeUrl(this.pageContext, "ms.vss-ciworkflow.ci-editor-route", { 
                                           project: tfsPageData.project.name, 
                                           source: SourceCICDActionMenu 
                                       });

            if (hasEditPermission) {
                // Create build definition
                this.menuItems.push({
                    id: "newBuildDefinition",
                    groupKey: "app-actions",
                    href: createPipelineLink,
                    iconProps: {
                        iconName: "Build"
                    },
                    rank: 100,
                    text: Resources.NewPipeline,
                });
            }
        }
    }

    public getMenuItems(menuId: string): IMenuItem[] | null {
        if (menuId === "ms.vss-tfs-web.vertical-header-create-menu") {
            return this.menuItems;
        }
        
        return null;
    }
}

Services.add("build-release-create-menu-provider", { serviceFactory: CreateMenuProviderService });
